<template>
  <div class="c-container" :class="{ 'c-container-pending': pending }">
    <div v-if="pending" class="c-pending-indicator">
      {{ $t('ppm_modal_pending') }}
    </div>
    <div class="c-main">
      <div class="c-main-left">
        <p class="c-card-type">
          {{ cardType }}
        </p>
      </div>
      <div v-if="$scopedSlots['bank-logo']" class="c-main-right">
        <slot name="bank-logo" />
      </div>
    </div>

    <div v-if="!pending" class="c-footer">
      <div class="c-footer-left">
        <p class="c-cardholder-name">
          {{ cardholderName }}
        </p>
        <div class="c-account-security">
          <p v-if="expirationDate" class="c-expiration-date">
            {{ expirationDate }}
          </p>
          <p class="c-card-number">
            {{ accountNumber || cardNumber }}
          </p>
        </div>
      </div>
      <div v-if="$scopedSlots['card-logo']" class="c-footer-right">
        <slot name="card-logo" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    cardType: {
      type: String,
      default: null,
    },
    cardholderName: {
      type: String,
      default: null,
    },
    accountNumber: {
      type: String,
      default: null,
    },
    cardNumber: {
      type: String,
      default: null,
    },
    expirationDate: {
      type: String,
      default: null,
    },
    pending: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="postcss" scoped>
.c-container {
  /* Base */
  @apply tw-flex tw-flex-col tw-min-h-[72px] tw-min-w-[232px] tw-rounded-[10px] tw-text-white;

  /* Desktop */
  @apply lg:tw-min-h-[112px] lg:tw-min-w-[336px];
}

.c-main {
  /* Base */
  @apply tw-flex tw-flex-1 tw-mx-2 tw-mt-1.5 tw-gap-2;

  /* Desktop */
  @apply lg:tw-mt-2;
}

.c-main-left {
  /* Base */
  @apply tw-flex tw-flex-1 tw-flex-col tw-overflow-hidden;
}

.c-main-right {
  /* Base */
  @apply tw-flex tw-flex-none;
}

.c-card-type {
  /* Base */
  @apply tw-text-[16px] tw-leading-[19px] tw-font-bold tw-overflow-ellipsis tw-overflow-hidden tw-whitespace-nowrap;
  font-family: 'Inria Sans', sans-serif;

  /* Desktop */
  @apply lg:tw-text-[28px] lg:tw-leading-[34px];
}

.c-cardholder-name {
  /* Base */
  @apply tw-text-sm tw-leading-4 tw-font-light tw-tracking-[0.08em] tw-overflow-ellipsis tw-overflow-hidden tw-whitespace-nowrap;
  font-family: 'Inria Sans', sans-serif;
}

.c-footer {
  /* Base */
  @apply tw-flex tw-flex-none tw-flex-row tw-items-end tw-mx-2 tw-mb-2 tw-gap-2;
}

.c-footer-left {
  /* Base */
  @apply tw-flex tw-flex-col tw-flex-1;
}

.c-account-security {
  /* Base */
  @apply tw-flex tw-items-center tw-justify-between tw-overflow-hidden tw-gap-0.5;

  /* Desktop */
  @apply lg:tw-flex-col-reverse lg:tw-items-stretch;
}

.c-footer-right {
  /* Base */
  @apply tw-flex tw-flex-none;
}

.c-expiration-date {
  /* Base */
  @apply tw-text-[11px] tw-leading-4 tw-tracking-[0.08em] tw-font-light tw-overflow-ellipsis tw-overflow-hidden tw-whitespace-nowrap;
  font-family: 'Inria Sans', sans-serif;
}

.c-card-number {
  /* Base */
  @apply tw-text-sm tw-leading-4 tw-font-light tw-overflow-ellipsis tw-overflow-hidden tw-whitespace-nowrap;
  font-family: 'Inria Sans', sans-serif;

  /* Desktop */
  @apply lg:tw-font-normal lg:tw-tracking-[0.08em];
}

.c-container-pending {
  @apply tw-relative tw-opacity-50;
}

.c-pending-indicator {
  /* Base */
  @apply tw-absolute tw-top-3 tw-right-3 tw-text-sm tw-font-semibold tw-uppercase tw-z-10;
  @apply tw-bg-white tw-border-[#0048BD] tw-text-[#0048BD] tw-border-2 tw-rounded-md tw-px-1;
  font-family: 'Inria Sans', sans-serif;
}
</style>
